import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoWhitespace]',
  standalone: true
})
export class NoWhitespaceDirective {
  constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const input = this.el.nativeElement.value;
    const sanitizedInput = input.replace(/\s/g, '');
    this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedInput);
    this.control.control?.setValue(sanitizedInput);
  }

}
